"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchConfiguration = fetchConfiguration;
var _getAxios = require("./getAxios");
var _getDefaultStorageUrls = require("./getDefaultStorageUrls");
var _logger = require("./logger");
const defaultLogger = _logger.mainLogger.createChild('configuration fetching');
async function get({
  configurationUrl,
  settingsStorage,
  logger = defaultLogger,
  axiosOptions
}) {
  const {
    data,
    status,
    statusText
  } = await (0, _getAxios.getAxios)(settingsStorage).get(configurationUrl, axiosOptions);
  if (status === 200) {
    logger.info(`Configuration downloaded`, {
      host: settingsStorage,
      path: configurationUrl
    });
    return data;
  }
  logger.error(new Error(`Unable to get configuration from host ${settingsStorage} and path ${configurationUrl}`));
  throw new Error(statusText);
}
async function fetchConfiguration(configurationUrl, options) {
  const {
    logger = defaultLogger,
    storageUrls = (0, _getDefaultStorageUrls.getDefaultStorageUrls)(),
    axiosOptions
  } = options ?? {};
  const urls = [storageUrls.settingsStorageCdn, storageUrls.settingsStorage, storageUrls.settingsSecondaryStorage];
  let lastError;
  for (const url of urls) {
    try {
      // eslint-disable-next-line no-await-in-loop -- This is intentional
      const result = await get({
        settingsStorage: url,
        configurationUrl,
        logger,
        axiosOptions
      });
      return result;
    } catch (error) {
      lastError = error;
    }
  }
  const errorToThrow = lastError instanceof Error ? lastError : new Error(lastError);
  throw errorToThrow;
}
